<template>
  <div class="app-container">
    <el-tabs v-model="activeIndex" type="border-card" v-tab-change:activeIndex="setActiveName">
      <el-tab-pane v-for="item in tabList" :key="item.name" :label="item.label" :name="item.name">
        <keep-alive>
          <component v-bind:is="item.name"></component>
        </keep-alive>
      </el-tab-pane>
    </el-tabs>

  </div>

</template>

<script>
import menuList from "@/views/systemManagement/roleMenuManager/menuList";
import roleMenuBinding from "@/views/systemManagement/roleMenuManager/roleMenuBinding";

export default {
  name: "index",
  components: {
    menuList,
    roleMenuBinding
  },
  data() {
    return {
      activeIndex: "menuList",
      tabList: [
        {name: 'menuList', label: "菜单管理"},
        {name: 'roleMenuBinding', label: "角色菜单绑定管理"}
      ]
    }
  }
}
</script>

<style scoped>

</style>